import React from "react";
import Revalidation from "./revalidacion";
import Desconsolidation from "./desconsolidacion";
import CargosDestino from "./cargosDestino";
import CargosMinimos from "./cargosMinimos";
import PreviosManiobras from "./previosManiobras";
import Custodia from "./custodia";
import Almacenaje from "./almacenaje";
import Refrigeration from "./refrigeracion";
import Congelation from "./congelacion";
import ServicioExtraordinario from "./servicioExtraordinario";
import CancelationFactura from "./cancelacionFactura";
import ContenedoresActivos from "./contenedoresActivos";
import RestosHumanos from "./restosHumanos";

const vistas = {
  revalidation: Revalidation,
  desconsolidation: Desconsolidation,
  cargos_destino: CargosDestino,
  cargos_minimos: CargosMinimos,
  previos_maniobras: PreviosManiobras,
  custodia: Custodia,
  almacenaje: Almacenaje,
  refrigeration: Refrigeration,
  congelation: Congelation,
  servicio_extraordinario: ServicioExtraordinario,
  cancelation_factura: CancelationFactura,
  contenedores_activos: ContenedoresActivos,
  restos_humanos: RestosHumanos,
};

function VistaDetalle({ concepto, onClose, tarifas, actualizarTarifa }) {
  const Componente = vistas[concepto];

  if (!Componente) {
    return <div>Vista no encontrada</div>;
  }

  return (
    <Componente
      onClose={onClose}
      valorActual={tarifas[concepto]}
      actualizarTarifa={actualizarTarifa}
      concepto={concepto}
    />
  );
}

export default VistaDetalle;
